import React from 'react';
import { Helmet } from 'react-helmet';
import { FileText, Plus, Search, Filter, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/components/ui/use-toast';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export default function ProcessosSystemPage() {
  const { toast } = useToast();

  const handleAction = () => {
    toast({
      title: "Ação Indisponível",
      description: "🚧 This feature isn't implemented yet—but don't worry! You can request it in your next prompt! 🚀",
    });
  };

  const dummyData = [
    { id: 1, numero: "0001234-56.2023.8.26.0000", comarca: "São Paulo", vara: "1ª Vara Cível", situacao: "Em andamento", natureza: "Cível", valor: 150000 },
    { id: 2, numero: "0009876-54.2023.8.26.0000", comarca: "Campinas", vara: "3ª Vara Trabalhista", situacao: "Aguardando", natureza: "Trabalhista", valor: 45000 },
  ];

  return (
    <div className="p-8 max-w-7xl mx-auto space-y-6">
      <Helmet>
        <title>Processos - PROVATIO</title>
      </Helmet>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg text-[#193D6D]">
            <FileText size={24} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Gestão de Processos</h1>
            <p className="text-slate-500">Controle completo de processos, impugnações e perícias.</p>
          </div>
        </div>
        <Button onClick={handleAction} className="bg-[#193D6D] hover:bg-blue-800 text-white">
          <Plus className="w-4 h-4 mr-2" /> Novo Processo
        </Button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="p-4 border-b bg-slate-50 flex gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4" />
            <Input placeholder="Buscar por número do processo..." className="pl-9 bg-white text-slate-900" />
          </div>
          <Button variant="outline" onClick={handleAction}>
            <Filter className="w-4 h-4 mr-2" /> Status / Comarca
          </Button>
        </div>

        <div className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Número do Processo</TableHead>
                <TableHead>Comarca / Vara</TableHead>
                <TableHead>Situação</TableHead>
                <TableHead>Natureza</TableHead>
                <TableHead className="text-right">Valor</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {dummyData.map((proc) => (
                <TableRow key={proc.id}>
                  <TableCell className="font-medium">{proc.numero}</TableCell>
                  <TableCell>{proc.comarca} - {proc.vara}</TableCell>
                  <TableCell>
                    <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">{proc.situacao}</span>
                  </TableCell>
                  <TableCell>{proc.natureza}</TableCell>
                  <TableCell className="text-right">
                    {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(proc.valor)}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button variant="ghost" size="icon" onClick={handleAction}><Eye className="w-4 h-4 text-slate-500" /></Button>
                      <Button variant="ghost" size="icon" onClick={handleAction}><Edit className="w-4 h-4 text-blue-500" /></Button>
                      <Button variant="ghost" size="icon" onClick={handleAction}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}